import React from 'react';
import { useFormikContext } from 'formik';
import { Button } from 'primereact/button';

const DocumentsToAcceptFormSubmitButton = () => {
  const { isValid, isSubmitting } = useFormikContext();

  return (
    <div className="center">
      <Button type="submit" className="p-button-primary" label="Got it!" disabled={!isValid || isSubmitting} />
    </div>
  );
};

export default DocumentsToAcceptFormSubmitButton;
